var Vendd = (function (Vendd) {
	'use strict';
    
	var model = null;
	var pending = false;

	Vendd.MessageBus.subscribe(Vendd.WishlistArticle.Messages.GetModel, Vendd.WishlistArticle, function (envelope) {

	    if (pending === true) {
	        return false;
	    };

	    pending = true;

	    function onSuccess(response) {
	        model = response.data;

	        Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.Changed(model));

	        pending = false;
	    }

	    function onFailure(response) {
	        Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.Failed(response));
	    }

	    var options = {
	        url: 'api/Wishlist/GetWishlistArticleViewModel',
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.WishlistArticle.Messages.Add, Vendd.WishlistArticle, function (envelope) {
	    var data = {};
	    data.item = envelope.message.data;

	    function onSuccess(response) {
	        if (response.success)
	            Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.GetModel());
	        else
	            Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.Failed(response));
        }

	    function onFailure(response) {
	        console.log("fail response:" + JSON.stringify(response));
	        Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.Failed(response));
	    }

	    var options = {
	        url: 'EcomService.svc/AddToWishlistArticle',
	        data: data,
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.WishlistArticle.Messages.Remove, Vendd.WishlistArticle, function (envelope) {
	    function onSuccess(response) {
            if (response.success)
                Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.GetModel());
            else
                Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.Failed(response));
        }

	    function onFailure(response) {
	        console.log("fail response:" + JSON.stringify(response));
	        Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.Failed(response));
        }

        var options = {
            url: 'EcomService.svc/RemoveFromWishlistArticle',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.WishlistArticle.Messages.Clear, Vendd.WishlistArticle, function (envelope) {
        function onSuccess (response) {
            if (response.success)
                Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.GetModel());
            else
                Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.Failed(response));
        }

        function onFailure (response) {
            Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.Failed(response));
        }

        var options = {
            url: 'EcomService.svc/ClearWishlistArticle',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

		Vendd.Service.call(options);
	});

	var dontLoadOnLoginSuccess;
	Vendd.MessageBus.subscribe(Vendd.User.Messages.Login, Vendd.WishlistArticle, function (envelope) {
		dontLoadOnLoginSuccess = envelope.message.data.options && envelope.message.data.options.isLoginForm;
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, Vendd.WishlistArticle, function (envelope) {
		if (dontLoadOnLoginSuccess)
			return;
		Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.GetModel());
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LogoutSuccess, Vendd.WishlistArticle, function (envelope) {
		if (dontLoadOnLoginSuccess)
			return;
		Vendd.MessageBus.publishAsync(Vendd.WishlistArticle, new Vendd.WishlistArticle.Messages.GetModel());
	});

	return Vendd;

})(Vendd || {});